import {
  checkRequestExportTask,
  loadRequestExportFieldsList,
  startRequestsExport,
} from '../../../../api'
import { useNotification } from '../../../../hooks'
import { getApiRequestFilterParams } from '../../../../utils/filter'
import { TableExportModal } from '../../../Table'
import {
  REQUEST_MASS_ACTION_ID_KEY,
  RequestTableExportOptionValue,
} from '../../Request.constants.actions'
import { RequestExportEmailsFilesChatsModal } from '../../RequestExportEmailsFilesChatsModal'
import { RequestExportInvoiceModal } from '../../RequestExportInvoiceModal'

export function useRequestTableHandleExport({
  excludeIds,
  filterValues,
  selectAllPages,
  selectedIds,
  sub,
  unselectAllPages,
  onCloseModal,
  onSetModal,
}) {
  const { handleAddSuccessNotification } = useNotification()

  function handleSubmitExportInvoice() {
    onCloseModal()

    unselectAllPages()

    handleAddSuccessNotification('Notification.RequestFileUploadingKey')
  }

  function handleOpenExportModal({ value: type }) {
    switch (type) {
      case RequestTableExportOptionValue.ExportTable:
        onSetModal(
          <TableExportModal
            checkTask={checkRequestExportTask}
            loadFieldList={loadRequestExportFieldsList}
            massActionIdKey={REQUEST_MASS_ACTION_ID_KEY}
            startExport={startRequestsExport}
            tableExportGetResponseLinkModalProps={{
              excludeIds,
              filterValues,
              getApiRequestFilterParams,
              massActionIdKey: REQUEST_MASS_ACTION_ID_KEY,
              selectAllPages,
              selectedIds,
              sub,
              unselectAllPages,
            }}
            onClose={onCloseModal}
          />
        )
        break

      case RequestTableExportOptionValue.ExportEmailsFilesChats:
        onSetModal(
          <RequestExportEmailsFilesChatsModal
            tableExportGetResponseLinkModalProps={{
              excludeIds,
              filterValues,
              getApiRequestFilterParams,
              massActionIdKey: REQUEST_MASS_ACTION_ID_KEY,
              selectAllPages,
              selectedIds,
              sub,
              unselectAllPages,
            }}
            onClose={onCloseModal}
          />
        )
        break

      case RequestTableExportOptionValue.ExportInvoice:
        onSetModal(
          <RequestExportInvoiceModal
            onClose={onCloseModal}
            onSubmit={handleSubmitExportInvoice}
          />
        )
        break
    }
  }

  return { handleOpenExportModal }
}
